export default __webpack_public_path__ + "static/media/better_me_mady.88dac4c6.jpg";